// Web: no font files in the bundle. The browser gets two small variable fonts from public/fonts,
// declared in src/fonts.ts, and picks the weight itself.
export const FONT_FILES: Record<string, number> = {};
